export interface AppealTopic {
    appealTopicId: string,
    appealTopicName: string,
    description: string,
    isArchive: boolean,
}

export interface AppealTag {
    appealTagId: string,
    appealTagName: string,
    description: string | null,
    appealTopicId: string,
    appealTopicName: string,
    parameterTagTempleteId: string | null,
    isArchive: boolean,
}

export interface AppealAdditionalTag {
    appealAdditionalTagId: string,
    appealAdditionalTagName: string,
    description: string | null,
    appealTagId: string,
    appealTagName: string,
    isArchive: boolean,
}

export interface AppealAdditionalTag {
    appealAdditionalTagId: string,
    appealAdditionalTagName: string,
    description: string | null,
    appealTagId: string,
    appealTagName: string,
    isArchive: boolean,
}

export interface AppealTagParameter {
    id: string,
    parameterTagTempleteId: string,
    orderNumber: number,
    parameterTagType: ParameterTagTypeEnum,
    parameterName: string,
    description: string,
    size: string,
    isRequired: boolean,
    IsIgnoreCreate: boolean,
    metaData: string[]
}

export enum ParameterTagTypeEnum {
    //DateTimeSlot = 1,
    Text = 2,
    TextArea = 3,
    Link = 4,
    LinkCollection = 5,
    File = 6,
    FileCollection = 7,
    //PaidAppeal = 8,
    //TimeSlotDispetcher = 9,
    //PersonalAccount = 10,
    //DeadlineDateExecution = 11,
    //TaskTagLink = 12,
    //CommonReference = 13,
    Date = 14,
    TextWithCode = 15,
    //MobileService = 16,
    CheckReadObly = 17
}

export enum ParameterTagTypeNameEnum {
    Text = "text",
    TextArea = 3,
    Link = 4,
    LinkCollection = 5,
    File = 6,
    FileCollection = 7,
    PersonalAccount = 10,
    Date = 14,
    CheckReadObly = 17
}

export interface ShortAppealData {
    taskTagId: string,
    serialNumber: number,
    appealTopicId: string,
    appealTopicName: string,
    appealTagId: string,
    appealTagName: string,
    dateCreate: Date,
    serviceObjectId: string,
    taskAdditionalTagNames: string[],
    isCompleted: boolean,
    taskTagStatusId: string,
    taskTagStatusName: string,
    quality: number | null
}

export interface AppealData {
    taskTagId: string,
    serialNumber: number,
    appealTopicId: string,
    appealTopicName: string,
    appealTagId: string,
    appealTagName: string,
    dateCreate: Date,
    serviceObjectId: string,
    taskAdditionalTagNames: string[],
    isCompleted: boolean,
    taskTagStatusId: string,
    taskTagStatusName: string,
    dateFinalStatus: Date,
    dateExecution: Date,
    taskTagParameters: TaskTagParameter[],
    quality: number | null

}

export interface TaskTagParameter {
    taskTagParameterId: string,
    taskTagId: string,
    parameterName: string,
    description: string,
    parameterTagType: number,
    orderNumber: number,
    isRequired: true,
    value: string[]
}

export interface CreateTaskTagCommand {

    personalAccountId: string | undefined,
    serviceObjectId: number | null,
    taskAppeals: {
        appealTopicId: string,
        taskTags: {
            appealTagId: string,
            parameters: Dictionary<any>,
            appealAdditionalTagsId: string[]
        }[]
    }[]
}


export interface Parameter {
    [key: string]: any
}

export interface Dictionary<T> {
    [Key: string]: T;
}